import React from 'react';
import { Play, Pause, Plus, MoreHorizontal, Clock } from 'lucide-react';
import { topMixes } from '../mock';
import { usePlayer } from '../context/PlayerContext';

const TopMixes = () => {
  const { current, isPlaying, play, togglePlay } = usePlayer();

  return (
    <section className="px-6 mt-12">
      <div className="flex items-end justify-between mb-4">
        <div>
          <h2 className="font-display text-2xl md:text-3xl text-white">Top Monthly Mixes</h2>
          <p className="text-neutral-500 text-xs mt-1">Curated by the Gulf Coast crew</p>
        </div>
        <button className="text-xs uppercase tracking-wider text-neutral-400 hover:text-white transition-colors">See all</button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        {topMixes.map((m) => {
          const active = current?.id === m.id && isPlaying;
          const onClick = () => (current?.id === m.id ? togglePlay() : play(m));
          return (
            <div
              key={m.id}
              className="card-hover p-3 rounded-xl bg-white/[0.03] border border-white/5 cursor-pointer"
            >
              <div className="relative aspect-square rounded-lg overflow-hidden">
                <img src={m.cover} alt={m.title} className="w-full h-full object-cover" />
                <button
                  onClick={onClick}
                  className="play-reveal absolute bottom-2 right-2 w-11 h-11 rounded-full bg-orange-500 hover:bg-orange-400 text-black flex items-center justify-center shadow-lg shadow-black/50"
                >
                  {active ? <Pause className="w-5 h-5" fill="currentColor" /> : <Play className="w-5 h-5 ml-0.5" fill="currentColor" />}
                </button>
                <div className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider rounded bg-black/60 text-orange-300 border border-white/10">
                  {m.genre}
                </div>
              </div>
              <div className="mt-3">
                <div className="text-sm font-semibold text-white line-clamp-1">{m.title}</div>
                <div className="text-xs text-neutral-400 line-clamp-1 mt-0.5">{m.artist}</div>
                <div className="flex items-center justify-between mt-2 text-[11px] text-neutral-500">
                  <div className="flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {m.duration}
                  </div>
                  <div>{m.plays} plays</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TopMixes;
